<template>
  <v-tailwind-modal v-model="rgroup_modalshow" @confirm="rgroup_confirm" @cancel="cancel">
    <template v-slot:title>{{ $t('editmesh.editgroup') }}</template>

    <div class="grid gap-4 sm:grid-cols-2">
      <div class="form-group mb-4">
        <label class="font-medium text-sm text-skin-b-list-mute" for="renamegroup">{{ $t('editmesh.groupname') }}</label>
        <input v-model="rgroup_modal" type="text" class="form-control
                mb-4 block w-full px-3 py-2 rounded-lg 
                font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                border-2 border-skin-b-list-bord 
                hover:bg-skin-b-list-head
                focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                " ref="renamegroup" id="renamegroup" aria-describedby="renamegroup" 
                :placeholder="$t('editmesh.groupname')">
   
        <label class="font-medium text-sm text-skin-b-list-mute" for="renameinfogroup">{{ $t('editmesh.groupinfo') }}</label>
        <input v-model="igroup_modal" type="text" class="form-control
        block w-full px-3 py-2 rounded-lg 
                font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                border-2 border-skin-b-list-bord 
                hover:bg-skin-b-list-head
                focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                " ref="renameinfogroup"  id="renameinfogroup" aria-describedby="renameinfogroup" 
                :placeholder="$t('editmesh.groupinfo')">
      </div>
      <div class="form-group mb-4">
        <label class="font-medium text-sm text-skin-b-list-mute" for="renamegroup">{{ $t('editmesh.publicrelease') }}</label>
        <div class="relative w-full inline-flex self-center">
                      <svg class="h-12 w-10 absolute ml-2 top-0 right-2 pointer-events-none p-2 text-skin-b-list-base" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor" aria-hidden="true">
                        <path d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h279v60H180v600h600v-279h60v279q0 24-18 42t-42 18H180Zm202-219-42-43 398-398H519v-60h321v321h-60v-218L382-339Z"/>
                      </svg>
                      <select name="pubAccessSchema" id="pubAccessSchema" 
                      v-model="vgroup_modal"
                      class="w-full h-12 pl-4 pr-12 appearance-none truncate
                      rounded-lg cursor-pointer disabled:cursor-default border-2 border-skin-b-list-bord
                      font-semibold text-lg text-skin-b-list-base
                      bg-skin-b-list-back
                      hover:bg-skin-b-list-head 
                      focus:outline-none focus:ring-0
                      transition duration-150 ease-in-out">
                      <option value="0">{{ $t('editmesh.norelease') }}</option>
                      <option v-for="(pa, index) in pubAccessTable" :key="index" :value="pa.id">
                        Nr. {{ index+1 }} - {{this.decodeHtml(pa.headline)}}
                      </option>
                      </select>  
                </div>
      </div>      
    </div>

  </v-tailwind-modal>

  <v-tailwind-modal v-model="rwbox_modalshow" @confirm="rwbox_confirm" @cancel="cancel">
    <template v-slot:title>{{ $t('editmesh.editwallbox') }}</template>

    <div class="grid gap-4 sm:grid-cols-2">
      <div class="form-group mb-4">
        <label class="font-medium text-sm text-skin-b-list-mute" for="renamewbox">{{ $t('editmesh.wallboxname') }}</label>
        <input v-model="rwbox_modal" type="text" class="form-control
                mb-4 block w-full px-3 py-2 rounded-lg 
                font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                border-2 border-skin-b-list-bord 
                hover:bg-skin-b-list-head
                focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                " ref="renamewbox" id="renamewbox" aria-describedby="renamewbox" 
                :placeholder="$t('editmesh.wallboxname')">
   
        <label class="font-medium text-sm text-skin-b-list-mute" for="renamewbox">{{ $t('editmesh.wallboxinfo') }}</label>
        <input v-model="iwbox_modal" type="text" class="form-control
        block w-full px-3 py-2 rounded-lg 
                font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
                border-2 border-skin-b-list-bord 
                hover:bg-skin-b-list-head
                focus:ring-transparent focus:border-skin-focus focus:bg-skin-active128/5 focus:outline-none focus:ring-0 
                " ref="renameinfo"  id="renameinfo" aria-describedby="renameinfo" 
                :placeholder="$t('editmesh.wallboxinfo')">
      </div>
      <div class="form-group mb-4">
        <label class="font-medium text-sm text-skin-b-list-mute">{{ $t('editmesh.ipadress') }}</label>
        <input disabled v-model="datawbox_modal.ip" type="text" class="form-control
          mb-4 block w-full px-3 py-2 rounded-lg 
          font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
          border-2 border-skin-b-list-bord 
          hover:bg-skin-b-list-head
          ">        
        <label class="font-medium text-sm text-skin-b-list-mute">{{ $t('editmesh.serial') }}</label>
        <input disabled v-model="datawbox_modal.serial" type="text" class="form-control
          block w-full px-3 py-2 rounded-lg 
          font-semibold text-lg text-skin-b-list-base disabled:text-skin-b-list-mute
          border-2 border-skin-b-list-bord 
          hover:bg-skin-b-list-head
          ">
      </div>


    </div>

  </v-tailwind-modal>

  <SrcBackground>

      <div class="w-full flex bg-skin-b-list-back divide-x md:border-x border-b border-skin-b-list-bord shadow lg:rounded-b-lg">
      <div class="inline-flex">
        <router-link to="/Main" custom v-slot="{ navigate }">
        <button type="button" @click="navigate" role="link"
        class="inline-flex items-center px-4 py-0 text-sm font-medium rounded-bl-lg
                                    text-skin-b-list-base bg-skin-b-list-back 
                                    hover:text-skin-b-base hover:bg-skin-b-list-head  
                                    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base 
                                    transition duration-300 ease-in-out">
        <svg class="w-8 h-8" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
          <path d="m13 18-8-8 8-8 1.417 1.417L7.833 10l6.584 6.583Z"></path>
        </svg>
        </button>
        </router-link>
      </div>

      <div class="inline-flex grow pl-6">
        <div class="my-auto pr-4 hidden sm:inline-block">
          <svg class="text-skin-b-list-mute" xmlns="http://www.w3.org/2000/svg" height="48" width="48" fill="currentColor">
            <path d="M11.3 40q-1.4 0-2.35-.95Q8 38.1 8 36.7q0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Zm0-12.7q-1.4 0-2.35-.95Q8 25.4 8 24q0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Zm0-12.7q-1.4 0-2.35-.95Q8 12.7 8 11.3q0-1.4.95-2.35Q9.9 8 11.3 8q1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95ZM24 27.3q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35.95-.95 2.35-.95 1.4 0 2.35.95.95.95.95 2.35Zm0-12.7q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35Q22.6 8 24 8q1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95ZM22 40v-3.25L34.15 24.6l3.25 3.25L25.25 40Zm14.7-25.4q-1.4 0-2.35-.95-.95-.95-.95-2.35 0-1.4.95-2.35Q35.3 8 36.7 8q1.4 0 2.35.95.95.95.95 2.35 0 1.4-.95 2.35-.95.95-2.35.95Zm2 11.95-3.25-3.25 1.25-1.25q.4-.4 1-.425.6-.025 1 .375l1.3 1.3q.4.4.375 1-.025.6-.425 1Z"/>    </svg>        
        </div> 

        <div class="py-4">
          <h1 class="font-bold text-skin-b-list-base text-2xl">{{ $t('editmesh.headline') }}</h1>
          <h4 class="font-medium text-skin-b-list-mute text-lg truncate">
          <span v-if="this.$store.state.WbClients?.length>0">{{ $t('mesh.wallbox', { count: this.$store.state.WbClients?.length }, this.$store.state.WbClients?.length ) }}</span>
          <span v-if="this.$store.state.wbgroups?.length>1"> &#8231; {{ $t('mesh.ingroup', { count: this.$store.state.wbgroups?.length-1 }, this.$store.state.wbgroups?.length-1 ) }}</span>
        </h4>
        </div>
      </div>

    </div>

    <div class="px-4 mt-4">
        <div class="flex justify-between">
          <button @click="addgroup" :disabled="changedmesh" v-if="dragging" 
            class="inline-block px-4 py-2 h-12
          rounded-lg border-2 border-transparent
          font-semibold text-lg text-skin-b-invt 
          bg-skin-active128
          disabled:opacity-50 disabled:hover:bg-skin-active128 
          hover:bg-skin-active96
          focus:bg-skin-active128 focus:outline-none focus:ring-0 
          active:bg-skin-active128 
          transition duration-300 ease-in-out">
          {{ $t('editmesh.addgrouptomesh') }}
          </button>
          <button @click="savemesh" :disabled="!changedmesh" v-if="dragging" 
          class="inline-block px-4 py-2 h-12
          rounded-lg border-2 border-transparent
          font-semibold text-lg text-skin-b-invt 
          bg-skin-active128
          disabled:opacity-50 disabled:hover:bg-skin-active128 
          hover:bg-skin-active96
          focus:bg-skin-active128 focus:outline-none focus:ring-0 
          active:bg-skin-active128 
          transition duration-300 ease-in-out">
          {{ $t('common.savechanges') }}
          </button>
        </div>
        <div class="mt-4" v-for="(boxgroup, index) in boxes.slice().reverse()" :key="index">

          <div class="flex items-end group justify-between p-4 bg-skin-b-list-head border border-skin-b-list-bord shadow rounded-t-lg">              
              <h4 class="font-semibold text-xl text-skin-base leading-tight truncate">
                <svg v-if="boxgroup.viewId==0" class="inline-block w-7 h-7 -mt-1 text-skin-base" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                  <path d="M5.5 16q-.625 0-1.062-.438Q4 15.125 4 14.5t.438-1.062Q4.875 13 5.5 13t1.062.438Q7 13.875 7 14.5t-.438 1.062Q6.125 16 5.5 16Zm4.5 0q-.625 0-1.062-.438Q8.5 15.125 8.5 14.5t.438-1.062Q9.375 13 10 13t1.062.438q.438.437.438 1.062t-.438 1.062Q10.625 16 10 16Zm4.5 0q-.625 0-1.062-.438Q13 15.125 13 14.5t.438-1.062Q13.875 13 14.5 13t1.062.438Q16 13.875 16 14.5t-.438 1.062Q15.125 16 14.5 16Zm-9-4.5q-.625 0-1.062-.438Q4 10.625 4 10t.438-1.062Q4.875 8.5 5.5 8.5t1.062.438Q7 9.375 7 10t-.438 1.062q-.437.438-1.062.438Zm4.5 0q-.625 0-1.062-.438Q8.5 10.625 8.5 10t.438-1.062Q9.375 8.5 10 8.5t1.062.438q.438.437.438 1.062t-.438 1.062q-.437.438-1.062.438Zm4.5 0q-.625 0-1.062-.438Q13 10.625 13 10t.438-1.062Q13.875 8.5 14.5 8.5t1.062.438Q16 9.375 16 10t-.438 1.062q-.437.438-1.062.438ZM5.5 7q-.625 0-1.062-.438Q4 6.125 4 5.5t.438-1.062Q4.875 4 5.5 4t1.062.438Q7 4.875 7 5.5t-.438 1.062Q6.125 7 5.5 7ZM10 7q-.625 0-1.062-.438Q8.5 6.125 8.5 5.5t.438-1.062Q9.375 4 10 4t1.062.438q.438.437.438 1.062t-.438 1.062Q10.625 7 10 7Zm4.5 0q-.625 0-1.062-.438Q13 6.125 13 5.5t.438-1.062Q13.875 4 14.5 4t1.062.438Q16 4.875 16 5.5t-.438 1.062Q15.125 7 14.5 7Z"></path>
                </svg>
                <svg v-if="boxgroup.viewId>0" class="inline-block w-7 h-7 -mt-1 text-skin-base" fill="currentColor" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg">
                  <path d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h279v60H180v600h600v-279h60v279q0 24-18 42t-42 18H180Zm202-219-42-43 398-398H519v-60h321v321h-60v-218L382-339Z"/>
                </svg>                             
                  {{ this.decodeHtml(boxgroup.name) }}
                  <span v-if="boxgroup.info!=''"> &#8231; <small>{{ this.decodeHtml(boxgroup.info) }}</small></span>
              </h4>

              <div v-if="dragging" class="relative items-center">
                      <button type="button" v-if="!(index==this.boxes.length-1)" class="inline-flex items-center px-2 py-1 text-sm font-medium 
                      text-skin-base bg-skin-b-list-head border-2 border-transparent
                      focus:z-10 focus:ring-0 focus:ring-transparent">
                        <svg class="w-6 h-6 fill-current" fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20" aria-hidden="true">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M263.788 648Q234 648 213 626.788q-21-21.213-21-51Q192 546 213.212 525q21.213-21 51-21Q294 504 315 525.212q21 21.213 21 51Q336 606 314.788 627q-21.213 21-51 21Zm216 0Q450 648 429 626.788q-21-21.213-21-51Q408 546 429.212 525q21.213-21 51-21Q510 504 531 525.212q21 21.213 21 51Q552 606 530.788 627q-21.213 21-51 21Zm216 0Q666 648 645 626.788q-21-21.213-21-51Q624 546 645.212 525q21.213-21 51-21Q726 504 747 525.212q21 21.213 21 51Q768 606 746.788 627q-21.213 21-51 21Z"/>
                        </svg>
                      </button>

                        <div  class="invisible group-hover:visible absolute top-0 right-0 inline-flex rounded-md shadow-sm" role="group">
                          <button @click="delgroup(boxgroup.id)" v-if="!(index==this.boxes.length-1)"
                          type="button" class="inline-flex items-center px-2 py-1 text-sm font-medium 
                          text-skin-b-list-base bg-skin-b-list-back border-l-2 border-y-2 border-skin-b-list-bord rounded-l-md
                          hover:text-red-800 hover:bg-red-100  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg class="w-6 h-6 fill-current" fill="currentColor" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                              <path d="m376-300 104-104 104 104 56-56-104-104 104-104-56-56-104 104-104-104-56 56 104 104-104 104 56 56Zm-96 180q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 56.5T680-120H280Zm400-600H280v520h400v-520Zm-400 0v520-520Z"/>
                          </svg>                          
                          </button>
                          <a v-if="boxgroup.viewId>0" :href="'https://'+this.$store.state.WbIp+'/#/Mesh?headline='+this.decodeHtml(pubAccessTable[pubAccessTable.findIndex(pa => pa.id == boxgroup.viewId)].headline)+'&schema='+pubAccessTable[pubAccessTable.findIndex(pa => pa.id == boxgroup.viewId)].schema+'&ip=https://'+this.$store.state.WbIp+'&logo='+pubAccessTable[pubAccessTable.findIndex(pa => pa.id == boxgroup.viewId)].logo.substring(1)+'&background='+pubAccessTable[pubAccessTable.findIndex(pa => pa.id == boxgroup.viewId)].background.substring(1)+'&pubtoken='+pubAccessTable[pubAccessTable.findIndex(pa => pa.id == boxgroup.viewId)].token" target="_blank" rel="noopener noreferrer"
                              class="inline-flex items-center px-2 py-1 text-sm font-medium
                                text-skin-b-list-base bg-skin-b-list-back border-l-2 border-y-2 border-skin-b-list-bord 
                                hover:text-skin-b-base hover:bg-skin-b-back  
                                focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                                <svg class="w-5 h-5 fill-current" fill="currentColor" viewBox="0 -960 960 960" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M180-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h279v60H180v600h600v-279h60v279q0 24-18 42t-42 18H180Zm202-219-42-43 398-398H519v-60h321v321h-60v-218L382-339Z"/>
                                </svg>
                          </a>
                          <button type="button" v-if="!(index==this.boxes.length-1)" @click="rgroup_modal=this.decodeHtml(boxgroup.name);igroup_modal=this.decodeHtml(boxgroup.info);vgroup_modal=boxgroup.viewId;rgroup_modalidx=this.boxes.length-index;rgroup_modalshow = true" 
                          :class="!(index==this.boxes.length-1) ? 'rounded-r-md' : 'rounded-md'"
                          class="inline-flex items-center px-2 py-1 text-sm font-medium 
                          text-skin-b-list-base bg-skin-b-list-back border-2 border-skin-b-list-bord 
                          hover:text-skin-b-base hover:bg-skin-b-back  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
                            <path d="m16.188 7.542-3.73-3.73 1.021-1.02q.521-.521 1.24-.521t1.239.521l1.25 1.25q.5.5.5 1.239 0 .74-.5 1.24Zm-1.23 1.229L6.229 17.5H2.5v-3.729l8.729-8.729Z"/>
                          </svg>
                          </button>
                        </div>


                    </div>






          </div>

          <div class="p-4 bg-skin-b-list-back border-x border-b border-skin-b-list-bord shadow rounded-b-lg">

          <draggable
            id="dropzone" class="list-group grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 justify-items-center gap-4 rounded-lg border-4 border-transparent"
            :class="{ 'border-dashed border-skin-focus' : highlight && drag }"
            style="min-height: 130px;"
            :list="boxgroup.group"
            :disabled="!dragging"
            group="people"
            @start="startDrag"
            @end="endDrag"
            :move="checkMove"           
            @change="log"
            itemKey="group"
          >
          <h4 v-if="boxgroup.group.length == 0" class="mt-1 mb-3 font-semibold text-lg text-skin-inverted leading-tight truncate">{{ $t('editmesh.movehere') }}</h4> 
            <template #item="{ element }">

              <div :class="{'not-draggable': !dragging, 'yes-draggable': dragging }"
                class="list-group-item group inline-block relative w-full overflow-hidden font-semibold rounded text-skin-b-list-mute hover:text-skin-b-list-base">
                <ul v-if="element.id&&element.wallboxStatus!='no_connection'" 
                  :class="element.id==this.$store.state.WbId ? 'border-skin-focus bg-skin-b-list-back group-hover:bg-skin-active128/10' : 'border-skin-b-list-bord group-hover:border-skin-focus bg-skin-b-list-back group-hover:bg-skin-active128/10'"
                  class="w-full rounded-t-lg border-b-2 cursor-pointer">
                  <li class="px-3 py-1 font-bold text-right text-skin-b-list-base text-base truncate">
                    {{ this.decodeHtml(element.name) }}
                  </li>
                </ul>
                <ul v-if="element.id&&element.wallboxStatus=='no_connection'" 
                  :class="element.id==this.$store.state.WbId ? 'border-skin-focus bg-skin-b-list-back group-hover:bg-skin-active128/10' : 'border-skin-b-list-bord group-hover:border-skin-focus bg-skin-b-list-back group-hover:bg-skin-active128/10'"
                  class="w-full rounded-t-lg border-b-2 cursor-pointer">
                  <li class="px-3 py-1 font-bold text-right text-skin-b-list-base text-base truncate">
                    {{ $t('statusshort.error') }}
                  </li>                  
                </ul>
                <!--Gehäuse oberer Teil-->                
                <svg class="-mt-2" fill="currentColor" width="200" height="8" viewbox="0 0 200 8" xmlns="http://www.w3.org/2000/svg">
                    <path v-if="element.name||element.info"  :d="svgdata[0].wb_housingtop"/>
                </svg>
                <svg class="" width="200" height="90" viewbox="0 0 200 90" xmlns="http://www.w3.org/2000/svg">
                  <!--Wallbox Inset-->
                  <g v-if="element.name||element.info">
                    <rect fill="currentColor" fill-opacity=".125" height="40.865341" rx="3.338637" ry="3.36538" width="29.570795" x="25.214592" y="15.153822"></rect>
                  </g>
                  <!--LEDs-->
                  <g v-if="element.name||element.info">
                    <path fill="currentColor" :d="svgdata[2].wb_leds"/>
                  </g>
                  <text class="font-bold text-xl" x="40" y="42" dominant-baseline="middle" text-anchor="middle" fill="currentColor">{{ element.idx+1 }}</text>                    
                  <!--Gehäuse unterer Teil-->
                  <path v-if="element.name||element.info" fill="currentColor" :d="svgdata[1].wb_housing"/>
                </svg>
                <div class="absolute top-11 right-2 w-24 ml-auto text-right">
                  <h4 class="font-bold text-sm text-skin-b-list-mute truncate">
                    {{ this.decodeHtml(element.info) }}
                  </h4>
                </div>




                <div class="items-center absolute bottom-4 right-0">
                      <button type="button" class="inline-flex items-center px-2 py-1 text-sm font-medium 
                      text-skin-b-list-base bg-skin-b-list-back border-2 border-transparent
                      focus:z-10 focus:ring-0 focus:ring-transparent">
                        <svg class="w-6 h-6 fill-current" fill="currentColor" xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 96 960 960" width="20" aria-hidden="true">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M263.788 648Q234 648 213 626.788q-21-21.213-21-51Q192 546 213.212 525q21.213-21 51-21Q294 504 315 525.212q21 21.213 21 51Q336 606 314.788 627q-21.213 21-51 21Zm216 0Q450 648 429 626.788q-21-21.213-21-51Q408 546 429.212 525q21.213-21 51-21Q510 504 531 525.212q21 21.213 21 51Q552 606 530.788 627q-21.213 21-51 21Zm216 0Q666 648 645 626.788q-21-21.213-21-51Q624 546 645.212 525q21.213-21 51-21Q726 504 747 525.212q21 21.213 21 51Q768 606 746.788 627q-21.213 21-51 21Z"/>
                        </svg>
                      </button>
                        <div class="invisible group-hover:visible absolute top-0 right-0 inline-flex rounded-md shadow-sm" role="group">
                          <button type="button" @click="rwbox_modal=this.decodeHtml(element.name);iwbox_modal=this.decodeHtml(element.info);datawbox_modal=element;rwbox_modalidx=element.id;rwbox_modalshow = true"
                           class="inline-flex items-center px-2 py-1 text-sm font-medium 
                          text-skin-b-list-base bg-skin-b-list-back border-2 border-skin-b-list-bord rounded-md 
                          hover:text-skin-b-base hover:bg-skin-b-back  
                          focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base">
                          <svg class="fill-current" xmlns="http://www.w3.org/2000/svg" height="20" width="20" fill="currentColor">
                            <path d="m16.188 7.542-3.73-3.73 1.021-1.02q.521-.521 1.24-.521t1.239.521l1.25 1.25q.5.5.5 1.239 0 .74-.5 1.24Zm-1.23 1.229L6.229 17.5H2.5v-3.729l8.729-8.729Z"/>
                          </svg>
                          </button>
                        </div>
                    </div>

              </div>
            </template>

            </draggable>
          </div>
        </div>

    </div>
    <div class="px-4 pt-12"></div>
  </SrcBackground>
</template>
<script>
import draggable from 'vuedraggable'
import SrcBackground from './sources/SrcBackground.vue'
import { useI18n } from 'vue-i18n'
export default {
  name: "SystemSortPage",
  display: "Two Lists",
  order: 1,
  components: {
    draggable, SrcBackground
  },
  setup () {
    const { t,d,n } = useI18n()
    return { t,d,n }
  },
  data() {
    return {
      svgdata: [
          {wb_housingtop:'m40 2c-6.6391 0-14.498228.0082969-15.986328.1542969-1.488.14587-2.604663.5780856-3.664063 1.3847656-1.0968.83516-2.297662 2.217115-2.976562 3.421875-.183688.3259747-.345767.6800343-.498047 1.0390625h46.324219c-.169624-.4363957-.360309-.8543302-.572266-1.2304688-.6789-1.2047699-1.879762-2.3953087-2.976562-3.2304687-1.0594-.80668-2.176063-1.2388956-3.664063-1.3847656-1.4881-.14588-9.347228-.1542969-15.986328-.1542969z'},
          {wb_housing:'m16.875 0c-.541357 1.2763508-.875 2.6889039-.875 3.7695312v54.2304688c0 1.61539.485147 3.307544 1.373047 4.115234 0 0 2.634028 2.346908 3.548828 2.923828.9147.576931 2.976259.544947 4.693359.691407 1.717.14646 4.883966.269531 14.384766.269531s12.667766-.123071 14.384766-.269531c1.7171-.14646 3.778659-.114476 4.693359-.691407.9148-.576919 3.548828-2.923828 3.548828-2.923828.8879-.80769 1.373047-2.499844 1.373047-4.115234v-54.2304688c0-1.033847-.300814-2.4832514-.800781-3.7695312zm14.9375.82421875c1.2022-.001 2.450469-.00096 3.667969 0 1.6233.001 3.191731.001953 4.519531.001953s2.896231-.00095313 4.519531-.001953c1.2175-.00096 2.465769-.001 3.667969 0 3.6066.004 6.795244.0219906 7.464844.0878906 1.1905.11669005 2.577081.41688685 3.425781 1.06054685.8525.6464501 1.302356 1.0680138 2.097656 2.3085938.7953 1.24057.886719 3.407945.886719 4.515625v47.806641c0 1.29231-.580616 2.646818-1.291016 3.292968 0 0-1.342418 1.300179-2.074218 1.761719s-.854916.628924-2.228516.746094c-1.3736.11716-8.86815.02344-16.46875.02344s-15.09515.09376-16.46875-.02344c-1.3736-.11717-1.496716-.284554-2.228516-.746094s-2.074218-1.761719-2.074218-1.761719c-.7104-.64615-1.291016-2.000658-1.291016-3.292968v-47.806641c0-1.10768.09152-3.275055.886719-4.515625.7953-1.24058 1.245156-1.6621438 2.097656-2.3085938.8487-.64366 2.235281-.9438568 3.425781-1.06054682.6696-.0656 3.858244-.0841906 7.464844-.0878906zm-3.259766 14.33007825c-1.8496 0-3.33789 1.500814-3.33789 3.365234v34.134766c0 1.86442 1.48829 3.365234 3.33789 3.365234h22.894532c1.8496 0 3.33789-1.500814 3.33789-3.365234v-34.134766c0-1.86442-1.48829-3.365234-3.33789-3.365234zm0 .480469h22.894532c1.5936 0 2.861328 1.278375 2.861328 2.884765v34.134766c0 1.6064-1.267728 2.884765-2.861328 2.884765h-22.894532c-1.5936 0-2.861328-1.278365-2.861328-2.884765v-34.134766c0-1.60639 1.267728-2.884765 2.861328-2.884765z'},
          {wb_leds:'m40 22.74988c-.6575 0-1.1935.53963-1.1935 1.20192 0 .6623.536 1.20193 1.1935 1.20193s1.1935-.53963 1.1935-1.20193c0-.66229-.536-1.20192-1.1935-1.20192zm-2.8431.26724c-.511.00001-.9283.4199-.9283.93468 0 .5148.4173.93487.9283.93488.5111.00001.9282-.42008.9282-.93488 0-.51479-.4171-.93469-.9282-.93468zm5.6862 0c-.5111-.00001-.9282.41989-.9282.93468 0 .5148.4171.93489.9282.93488.511-.00001.9283-.42008.9283-.93488 0-.51478-.4173-.93467-.9283-.93468zm-7.9988.26706c-.3645-.00001-.6631.30034-.6631.66762 0 .3673.2986.66783.6631.66782.3645 0 .6629-.30053.6629-.66782 0-.36727-.2984-.66762-.6629-.66762zm10.3114 0c-.3645 0-.6629.30035-.6629.66762 0 .36729.2984.66782.6629.66782.3645.00001.6631-.30052.6631-.66782 0-.36728-.2986-.66763-.6631-.66762z'},
          {wb_rfidlogo:'m27.498047 27.193359c-2.332614 2.332618-3.498047 5.332952-3.498047 8.332032 0 2.999081 1.165433 5.99746 3.498047 8.330078l1.333984-1.332031c-1.832768-1.999387-2.832031-4.498813-2.832031-6.998047 0-2.499233.999263-4.99866 2.832031-6.998047zm25.003906 0-1.333984 1.333985c1.832768 1.999387 2.832031 4.498814 2.832031 6.998047 0 2.499234-.999262 4.998659-2.832031 6.998047l1.333984 1.332031c2.332614-2.332618 3.498047-5.330997 3.498047-8.330078 0-2.99908-1.165433-5.999414-3.498047-8.332032zm-22.337891 2.833985c-1.499538 1.49954-2.332031 3.498661-2.332031 5.498047 0 1.999387.832493 3.998507 2.332031 5.498047l1.333985-1.333985c-1.166307-1.166309-1.666016-2.664521-1.666016-4.164062 0-1.49954.499709-2.999707 1.666016-4.166016zm19.671876 0-1.333985 1.332031c1.166307 1.166309 1.666016 2.666476 1.666016 4.166016 0 1.039741-.258453 2.071471-.794922 3v-.361329l-2.765625-2.792968v-2.65625c0-.946952-.766168-1.722657-1.708984-1.722656h-9.673829c-.942814 0-1.708984.775704-1.708984 1.722656v5.583984c0 .946952.76617 1.722655 1.708984 1.722656h5.144532l5.757812 6.978516h6.009766v-.326172-1.53125l-2.763672-2.791016v-1.789062l.462891.460938c1.499538-1.499542 2.332031-3.49866 2.332031-5.498047 0-1.999386-.832493-3.998507-2.332031-5.498047zm-14.611329 1.617187h9.673829c.588661 0 1.05664.470596 1.05664 1.070313v1.998047 3.585937c0 .431598-.246575.788721-.601562.958984-.05819.02309-.111319.03745-.164063.05078-.09409.02718-.187519.05859-.291015.05859h-.681641l-2.248047-2.677735-.0039-.0039c-.471031-.535022-.962352-.853092-1.4375-.978516-.475139-.125424-.936772-.04624-1.279297.199219-.685066.490919-.813945 1.564949-.150391 2.572266l.0098.01367.722656.875h-4.605469c-.588658 0-1.05664-.468643-1.05664-1.06836v-5.583984c0-.599717.467982-1.070313 1.05664-1.070313zm11.382813 4.65625 2.111328 2.13086v4.1875l2.763672 2.792968v.935547h-5.046875l-6.796875-8.238281c-.525834-.805221-.358639-1.421834-.0098-1.671875.175166-.125522.415428-.18133.732422-.09766.316789.08362.707123.316285 1.113281.777344l2.4375 2.904296h.605469.38086s.110113-.000232.271484-.02734c.06549-.01063.128609-.02698.191406-.04492.04435-.01165.08734-.02688.134766-.04297.0344-.01304.06825-.02584.101562-.04102.04703-.01892.09277-.03052.140625-.05469.287754-.145305.574411-.430495.736328-.84375.02889-.07374.0529-.149757.07227-.232422.03672-.140112.06055-.284222.06055-.435547z'},
          {cable_carconnect:'m38.5 66v40.99982c0 7.71422 6.2858 14 14 14s14-6.28578 14-14v-4.75195c0-.9722.4708-1.83762 1.1934-2.38672l.3066.51172c1.5-1.125 5.25-3.75 7.125-3.75h9.875c.554 0 1-.446 1-1v-5c0-.554-.446-1-1-1h-9.875c-3.75-.018-7.875 5.125-9.375 7l.3906.65234c-1.5937 1.0783-2.6406 2.90246-2.6406 4.97266v4.75195c0 6.0929-4.9071 11-11 11s-11-4.9071-11-11v-40.99982z'},
          {cable_wbconnect:'m64 47.00305c-.554 0-1 .446-1 1v5c0 .554.446 1 1 1h9.875c1.875 0 5.625 2.625 7.125 3.75l.3066-.51172c.7226.5491 1.1934 1.41452 1.1934 2.38672v26.75195h-.016c0 11.3396-9.1604 20.5-20.5 20.5s-20.5-9.1604-20.5-20.5h.016v-20.38h-3v20.38h-.016c0 12.96092 10.5391 23.5 23.5 23.5s23.5-10.53908 23.5-23.5h.016v-26.75195c0-2.0702-1.0469-3.89436-2.6406-4.97266l.3906-.65234c-1.5-1.875-5.625-7.018-9.375-7z'},
          {car_full:'m126.91666 67.00187c-8.93316.0353-24.90416.77704-37.260232 4.08008-1.225077.32751-2.183637 1.1126-3.273605 2.10352s-2.244641 2.22879-3.435716 3.5664c-2.382349 2.67524-4.912908 5.76014-6.998538 7.86328l-.035.0332-.031.0371c-1.462791 1.68073-1.499094 3.98231-1.648503 6.51757-.147509 2.50206-.16641 5.20687-.421926 7.21094-.934559 3.10036-2.157836 5.43439-1.720808 8.19727.0002.001-.0002.003 0 .004.878255 6.064 2.068229 9.33158 3.939647 11.23633 1.874317 1.90758 4.251866 1.9375 6.144985 1.9375h1.544997c2.050929 4.32112 6.333197 7.20457 11.188201 7.21094 4.857205-.004 9.140268-2.88788 11.192098-7.21094h54.71833c2.05073 4.32147 6.333 7.20457 11.1882 7.21094 4.85721-.004 9.14217-2.88784 11.194-7.21094h.85166c2.75357 0 5.90107.005 8.79155-.35547l.02-.002.02-.004c1.05747-.16034 2.59976-.37546 4.02566-.91992.71285-.27223 1.41629-.62393 2.01762-1.20508.60105-.58075 1.06947-1.48143 1.06257-2.45507.017-4.12063.052-9.14414-.34373-11.72266-1.01975-6.81654-4.30607-10.53846-8.1392-13.49219l-.082-.0625-.088-.0508c-2.15523-1.23148-5.29903-2.06117-8.79545-2.88476-3.49652-.8236-7.30946-1.5882-10.50456-2.41602l-.039-.01-.041-.008c-1.70731-.34392-3.1046-.70752-3.71514-1.3125l-.082-.082-.094-.0664c-15.24065-11.05792-21.61235-12.8365-25.85522-13.9707-4.21106-1.12574-6.3766-1.80286-15.30166-1.76758z'},
          {car_line:'m126.91666 67.00187c-8.93316.0353-24.90416.77704-37.260232 4.08008-1.225077.32751-2.183637 1.1126-3.273605 2.10352s-2.244641 2.22879-3.435716 3.5664c-2.382349 2.67524-4.912908 5.76014-6.998538 7.86328l-.035.0332-.031.0371c-1.462791 1.68073-1.499094 3.98231-1.648503 6.51757-.147509 2.50206-.16641 5.20687-.421926 7.21094-.934559 3.10036-2.157836 5.43439-1.720808 8.19727.0002.001-.0002.003 0 .004.878255 6.064 2.068229 9.33158 3.939647 11.23633 1.874317 1.90758 4.251866 1.9375 6.144985 1.9375h1.544997c2.050929 4.32112 6.333197 7.20457 11.188201 7.21094 4.857205-.004 9.140268-2.88788 11.192098-7.21094h54.71833c2.05073 4.32147 6.333 7.20457 11.1882 7.21094 4.85721-.004 9.14217-2.88784 11.194-7.21094h.85166c2.75357 0 5.90107.005 8.79155-.35547l.02-.002.02-.004c1.05747-.16034 2.59976-.37546 4.02566-.91992.71285-.27223 1.41629-.62393 2.01762-1.20508.60105-.58075 1.06947-1.48143 1.06257-2.45507.017-4.12063.052-9.14414-.34373-11.72266-1.01975-6.81654-4.30607-10.53846-8.1392-13.49219l-.082-.0625-.088-.0508c-2.15523-1.23148-5.29903-2.06117-8.79545-2.88476-3.49652-.8236-7.30946-1.5882-10.50456-2.41602l-.039-.01-.041-.008c-1.70731-.34392-3.1046-.70752-3.71514-1.3125l-.082-.082-.094-.0664c-15.24065-11.05792-21.61235-12.8365-25.85522-13.9707-4.21106-1.12574-6.3766-1.80286-15.30166-1.76758zm.012 2.99414c8.78396-.0347 10.24885.52516 14.51651 1.66602 4.23607 1.13239 9.82042 2.58016 24.87066 13.5l-.17381-.14844c1.5333 1.51953 3.55963 1.78601 5.23273 2.12305 3.30231.85217 7.08815 1.61151 10.48706 2.41211 3.38821.7981 6.4021 1.68997 7.9262 2.54297 3.51322 2.72304 6.00267 5.44471 6.90473 11.47461v.004.002c.29182 1.89998.32702 7.16338.31052 11.27929v.01.008c0 .12856.01.12624-.15031.28125-.16041.15501-.52263.37597-1.00596.56055-.96006.3666-2.32725.59162-3.38302.75195-2.61366.32455-5.65635.33203-8.40482.33203h-2.75798l-.35942.98047c-1.37298 3.74184-4.93061 6.22636-8.92826 6.23047-3.99675-.005-7.55187-2.48962-8.92446-6.23047l-.36132-.98047h-58.52907l-.36132.98047c-1.37269 3.74119-4.929512 6.22551-8.926362 6.23047-3.996751-.005-7.553774-2.48962-8.92636-6.23047l-.359323-.98047h-3.451416c-1.893119 0-2.958486.0292-4.010052-1.04101-1.051565-1.07024-2.271142-3.75821-3.113495-9.58789v-.01-.01c-.242715-1.52909.669042-3.60732 1.677905-7.01562l.033-.11328.016-.11524c.308219-2.33451.305419-5.1157.447328-7.52343.141808-2.40774.677742-4.45254.917957-4.72852l-.066.0723c2.258542-2.27749 4.7897-5.37504 7.109846-7.98047 1.160073-1.30272 2.265642-2.48044 3.213101-3.3418.94746-.86136 1.803813-1.36443 2.033328-1.42578 11.835643-3.16394 27.722633-3.94383 36.498383-3.97852z'},
          {car_linebattery:'m126.90933 67.00177c-8.9345.0357-24.8992.77792-37.252004 4.08008-1.2251.32751-2.1854 1.1126-3.2754 2.10352s-2.2444 2.22879-3.4355 3.5664c-2.3824 2.67524-4.9124 5.76014-6.9981 7.86328l-.035.0332-.031.0371c-1.4627 1.68073-1.499 3.98232-1.6484 6.51757-.1475 2.50208-.1664 5.20687-.4219 7.21094-.9345 3.10036-2.1577 5.43439-1.7207 8.19727.0002.001-.0002.003 0 .004.8783 6.064 2.068 9.33158 3.9394 11.23633 1.8743 1.90758 4.2534 1.9375 6.1465 1.9375h1.545c1.4021 2.95418 3.8467 5.23444 6.8046 6.38477-.3372-.76839-.5273-1.61236-.5273-2.49805v-1.03906c-1.8129-1.09298-3.2508-2.78217-4.0137-4.86133l-.3593-.98047h-3.4532c-1.8931 0-2.9581.0292-4.0097-1.04101-1.0516-1.07024-2.271-3.75821-3.1133-9.58789v-.01-.01c-.2427-1.52909.6688-3.60732 1.6777-7.01562l.033-.11328.016-.11524c.3082-2.33451.3054-5.1157.4473-7.52343.1413-2.39844.6725-4.4322.9141-4.72071 2.2434-2.2717 4.749-5.33334 7.0488-7.91601 1.1601-1.30272 2.2655-2.48044 3.2129-3.3418.9475-.86136 1.8036-1.36443 2.0332-1.42578 11.834804-3.16373 27.720004-3.94373 36.496104-3.97852 8.7821-.0346 10.2464.52525 14.5137 1.66602 4.236 1.13239 9.8209 2.58016 24.8711 13.5 1.5111 1.37855 3.4461 1.64979 5.0585 1.97461 3.3023.85217 7.0894 1.61151 10.4883 2.41211 3.3882.7981 6.4017 1.68997 7.9258 2.54297 3.5132 2.72304 6.0023 5.44471 6.9043 11.47461v.004.002c.2918 1.89998.3271 7.16338.3106 11.27929v.01.008c0 .12856.01.12624-.1504.28125s-.5226.37597-1.0059.56055c-.9601.3666-2.3271.59162-3.3828.75195-2.6137.32455-5.6558.33203-8.4043.33203h-2.7578l-.3594.98047c-1.373 3.74184-4.9321 6.22636-8.9297 6.23047-3.9968-.005-7.5512-2.48962-8.9238-6.23047l-.3613-.98047h-41.7272v2.99414h39.8203c2.0507 4.32147 6.3323 7.20457 11.1875 7.21094 4.8572-.004 9.1434-2.88784 11.1953-7.21094h.8516c2.7536 0 5.9005.005 8.791-.35547l.02-.002.021-.004c1.0574-.16034 2.5995-.37546 4.0254-.91992.7129-.27223 1.4162-.62393 2.0176-1.20508.601-.58075 1.0694-1.48143 1.0625-2.45507.017-4.12063.052-9.14414-.3438-11.72266-1.0198-6.81654-4.3055-10.53846-8.1386-13.49219l-.082-.0625-.09-.0508c-2.1553-1.23148-5.2984-2.06117-8.7949-2.88476-3.4965-.8236-7.3088-1.5882-10.5039-2.41602l-.039-.01-.041-.008c-1.7073-.34392-3.1043-.70752-3.7149-1.3125l-.082-.082-.094-.0664c-15.2406-11.05792-21.6126-12.8365-25.8555-13.9707-4.2098-1.12538-6.377-1.80239-15.2949-1.76758zm-26.4102 9.99805v5h-4.175804c-1.825 0-3.3242 1.49921-3.3242 3.32422v38.35156c0 1.82501 1.4997 3.32422 3.3496 3.32422h18.326204c1.825 0 3.3242-1.49962 3.3242-3.34961v-38.32617c0-1.82501-1.4992-3.32422-3.3242-3.32422h-4.1758v-5zm-3.500004 8h17.000004c.5523.00006.9999.44774 1 1v37c-.0001.55226-.4477.99994-1 1h-17.000004c-.5523-.00006-.9999-.44774-1-1v-37c.0001-.55226.4477-.99994 1-1z'}
        ],
      boxes : [],
      pubAccessTable: [],
      dragging: true,
      changedmesh: false,
      highlight: false,
      drag: false,
      rgroup_modalshow: false,
      rgroup_modal: '',
      igroup_modal: '',
      vgroup_modal: 0,
      rgroup_modalidx: 1,
      rwbox_modalshow: false,
      rwbox_modal: '',
      iwbox_modal: '',
      datawbox_modal: [],
      rwbox_modalidx: 1
    };
  },
  methods: {
    decodeHtml: function(html) {
    let txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
    },
    addgroup() {
      let size = this.$t('editmesh.group')+' '+this.boxes.length;
      this.axios
      .get('wallbox/client.php?action=update_group&id=-1&idx='+this.boxes.length+'&priority=-1&name='+size+'&info=-1&user='+this.$store.state.token)
      .then((response) => {         
                  if(response.data.status=='ok'){ 
                    this.updatemesh();
                  }else{
                    console.log('Error add group');                   
                  }
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });
    },
    delgroup(del) {
      this.axios
      .get('wallbox/client.php?action=delete_group&id='+del+'&user='+this.$store.state.token)
      .then((response) => {         
                  if(response.data.status=='ok'){
                    this.updatemesh();
                  }else{
                    console.log('Error delete group');                   
                  }
                })
                .catch((errors) => {
                    console.log(errors); // Errors
                });
    },
    checkMove: function(evt){
      if(evt.to.id === "dropzone") {
        this.highlight = true;
      } else {
        this.highlight = false;
      }
      this.changedmesh=true;
    },
    endDrag() {
      this.drag = false;
      this.highlight = false;
    },
    startDrag() {
      this.drag = true;
    },
    log: function() {  
    },
    savemesh: function() {
      let promises = [];
      for(var g=0;g<this.boxes.length;g++){
        for(var b=0;b<this.boxes[g].group.length;b++){
          var master = -1;
          if(b==0) master = this.boxes[g].id;
            promises.push(
              'wallbox/client.php?action=update_client&id='+this.boxes[g].group[b].id+'&groupId='+this.boxes[g].id+'&idx='+b+'&master='+master+'&name=-1&info=-1&user='+this.$store.state.token
            )
         }
      }
      Promise.all(promises.map((promises) => this.axios.get(promises))).then(
      this.axios.spread((...allData) => {
      this.updatemesh(allData)
      })
      );
    },
    updatemesh() {
      this.boxes = [];
      this.changedmesh = false;
      let CallgroupsUrl = 'wallbox/client.php?action=get_groups&user='+this.$store.state.token;
      let CallmeshUrl = 'wallbox/client.php?action=get_clients&user='+this.$store.state.token;
        const requestCallgroups = this.axios.get(CallgroupsUrl);
        const requestCallmesh = this.axios.get(CallmeshUrl);
        this.axios
            .all([requestCallgroups, requestCallmesh])
            .then(
                this.axios.spread((...responses) => {
                    const responseCallgroups = responses[0];
                    const responseCallmesh = responses[1];

                    this.$store.state.wbgroups = responseCallgroups.data.tbl_groups;
                    this.$store.state.wbgroups.forEach(item => { 

                        item.name = this.decodeHtml(item.name);
                        item.info = this.decodeHtml(item.info);
                    });
                    for(var j=0;j<this.$store.state.wbgroups.length;j++){
                      this.boxes.push({id: this.$store.state.wbgroups[j].id, name: this.$store.state.wbgroups[j].name, info: this.$store.state.wbgroups[j].info, viewId: this.$store.state.wbgroups[j].viewId, group: []});
                    }              
                    
                    this.$store.state.WbClients = responseCallmesh.data.tbl_clients.sort((a,b) => a.idx - b.idx);
                    this.$store.state.WbClients.forEach(item => { 
                      
                      item.name = this.decodeHtml(item.name);
                      item.info = this.decodeHtml(item.info);
                    });
                    for( var n = 0; n < this.$store.state.WbClients.length; n++){ 
                        if ( this.$store.state.WbClients[n].wallboxStatus === 'no_connection') { 
                          this.$store.state.WbClients.splice(n, 1); 
                        }
                    }                    
                    for(var i=0;i<this.$store.state.WbClients.length;i++){
                      for(var g=0;g<this.boxes.length;g++){
                        if(this.$store.state.WbClients[i].groupId==this.boxes[g].id){
                          this.boxes[g].group.push(this.$store.state.WbClients[i]);                     
                        }
                      }
                    }
                    if(this.boxes.length==1){
                      this.boxes[0].name='';
                      this.boxes[0].info='';
                    }else{
                      this.boxes[0].name=this.$t('mesh.noassignment');
                      this.boxes[0].info='';
                    }           
                })
            )
            .catch((errors) => {
                console.error(errors);
            });
    },
    rgroup_confirm() {
      this.boxes[this.rgroup_modalidx-1].name=this.rgroup_modal;
      this.boxes[this.rgroup_modalidx-1].info=this.igroup_modal;
      this.boxes[this.rgroup_modalidx-1].viewId=this.vgroup_modal;
      let eu_rgroup_modal = encodeURIComponent(this.rgroup_modal);
      let eu_igroup_modal = encodeURIComponent(this.igroup_modal);
      this.axios.get('wallbox/client.php?action=update_group&id='+this.boxes[this.rgroup_modalidx-1].id+'&name='+eu_rgroup_modal+'&info='+eu_igroup_modal+'&viewId='+this.vgroup_modal+'&user='+this.$store.state.token);
      this.rgroup_modalshow = false;
    },
    rwbox_confirm() {
      for(var g=0;g<this.boxes.length;g++){
        for(var b=0;b<this.boxes[g].group.length;b++){
          if(this.boxes[g].group[b].id==this.rwbox_modalidx){
            this.boxes[g].group[b].name=this.rwbox_modal;
            this.boxes[g].group[b].info=this.iwbox_modal;
          } 
         }
      }
      let eu_rwbox_modal = encodeURIComponent(this.rwbox_modal);
      let eu_iwbox_modal = encodeURIComponent(this.iwbox_modal);
      this.axios.get('wallbox/client.php?action=update_client&id='+this.rwbox_modalidx+'&name='+eu_rwbox_modal+'&info='+eu_iwbox_modal+'&user='+this.$store.state.token);
      this.rwbox_modalshow = false;
    },
    cancel(close) {
      // some code...
      close()
    }
  },
  created() {
    //const {t} = useI18n();
    let CallgroupsUrl = 'wallbox/client.php?action=get_groups&user='+this.$store.state.token;
    let CallmeshUrl = 'wallbox/client.php?action=get_clients&user='+this.$store.state.token;
    let CallPublicAccessUrl = 'wallbox/info.php?action=get_puplic_access&user='+this.$store.state.token;
      const requestCallgroups = this.axios.get(CallgroupsUrl);
      const requestCallmesh = this.axios.get(CallmeshUrl);
      const requestCallPublicAccess = this.axios.get(CallPublicAccessUrl);
      this.axios
          .all([requestCallgroups, requestCallmesh, requestCallPublicAccess])
          .then(
              this.axios.spread((...responses) => {
                  const responseCallgroups = responses[0];
                  const responseCallmesh = responses[1];
                  const responseCallPublicAccess = responses[2];

                  if(responseCallgroups.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseCallmesh.data.status=='token'){
                        this.$router.push({path: '/'});             
                  }else if(responseCallgroups.data.status=='ok'&&responseCallmesh.data.status=='ok'){

                    this.$store.state.wbgroups = responseCallgroups.data.tbl_groups;
                    
                    this.$store.state.wbgroups.forEach(item => { 
                        item.name = this.decodeHtml(item.name);
                        item.info = this.decodeHtml(item.info);
                    }); 
                    
                    for(var j=0;j<this.$store.state.wbgroups.length;j++){
                      this.boxes.push({id: this.$store.state.wbgroups[j].id, name: this.$store.state.wbgroups[j].name, info: this.$store.state.wbgroups[j].info, viewId: this.$store.state.wbgroups[j].viewId, group: []});
                    }              
                    
                    this.$store.state.WbClients = responseCallmesh.data.tbl_clients.sort((a,b) => a.idx - b.idx);
                    this.$store.state.WbClients.forEach(item => { 
                        item.name = this.decodeHtml(item.name);
                        item.info = this.decodeHtml(item.info);
                        
                      });
                    
                    for( var n = 0; n < this.$store.state.WbClients.length; n++){ 
                          if ( this.$store.state.WbClients[n].wallboxStatus === 'no_connection') { 
                            this.$store.state.WbClients.splice(n, 1); 
                          }
                      }

                    for(var i=0;i<this.$store.state.WbClients.length;i++){
                      for(var g=0;g<this.boxes.length;g++){
                        if(this.$store.state.WbClients[i].groupId==this.boxes[g].id){
                          this.boxes[g].group.push(this.$store.state.WbClients[i]);                     
                        }
                      }
                    }
                    if(this.boxes.length==1){
                      this.boxes[0].name='';
                      this.boxes[0].info='';
                    }else{
                      this.boxes[0].name=this.$t('mesh.noassignment');
                      this.boxes[0].info='';
                    }
                }else{
                  console.log('Error get Groups Clients');
                }

                if(responseCallPublicAccess.data.status=='token'){
                        this.$router.push({path: '/'});             
                }else if(responseCallPublicAccess.data.status=='ok'){
                  this.pubAccessTable = responseCallPublicAccess.data.tbl_public_access;
                }else{
                  console.log('Error get Public Access');
                }
              })
          )
          .catch((errors) => {
              console.error(errors);
          });
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.not-draggable {
  cursor: default;
}
.yes-draggable {
  cursor: pointer;
}
</style>
